import React from 'react';
import { motion } from 'framer-motion';

const HeroSection = () => {
  return (
    <section className="relative bg-white py-16 sm:py-20 lg:py-28">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-5 gap-10 lg:gap-16 items-center">
          <motion.div
            initial={{ opacity: 0, x: -40 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.7 }}
            viewport={{ once: true }}
            className="lg:col-span-2"
          >
            <p className="text-sm font-semibold tracking-widest uppercase text-cyan-600 mb-4">Our approach</p>
            <h2 className="text-3xl sm:text-4xl lg:text-5xl font-source text-[#0F2744] leading-tight mb-6">
              <span className="italic font-light">from</span> doubt...
              <br />
              <span className="italic font-light">to</span> direction
            </h2>
            <p className="text-lg text-slate-700 leading-relaxed mb-4 font-sans">
              Clarity isn&apos;t just information — it&apos;s that moment when everything clicks.
            </p>
            <p className="text-base text-slate-600 leading-relaxed font-sans">
              Our Analytical Prism approach fuses rigorous research with cultural intelligence,
              so learners emerge with the inner certainty to take the next step.
            </p>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, x: 40 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.7, delay: 0.1 }}
            viewport={{ once: true }}
            className="lg:col-span-3"
          >
            <div className="relative rounded-3xl overflow-hidden shadow-2xl shadow-slate-900/10 ring-1 ring-slate-200">
              <div
                className="aspect-[16/10] bg-cover bg-center"
                style={{ backgroundImage: 'url(/images/hero-image.png)' }}
              />
              <div className="absolute inset-0 bg-gradient-to-t from-[#0F2744]/80 via-transparent to-transparent" />
              <div className="absolute bottom-6 left-6 right-6">
                <div className="inline-block bg-white/95 backdrop-blur-sm rounded-xl px-5 py-3 shadow-lg">
                  <p className="text-sm font-medium text-[#0F2744]">
                    Rooted in <span className="font-bold">Science.</span> Shaping the <span className="font-bold">Future.</span>
                  </p>
                </div>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
